import React from "react";
import ContactMe from "./ContactMe/ContactMe";
import Me from "./Me";
import Projects from "./projects/Projects";

const Home = () => {
  return (
    <div>
      <Me></Me>
      <div id="projects">
        <Projects></Projects>
      </div>
      <div id="contactMe">
        <ContactMe></ContactMe>
      </div>
    </div>
  );
};

export default Home;
